import { useEffect, useState } from "react";
import { ToDateJalali, compaireTwoDate } from "../../../Function/index";
import moment from "jalali-moment";
import { Get } from "../../../../../Request";
export const useTableWeek = () => {
  const [week, setWeek] = useState({
    week: true,
  });

  const [days, setDays] = useState();
  const [loadingWeek, setLoadingWeek] = useState(true);
  const [loadingSans, setLoadingSans] = useState(false);
  const getWeek = data => {
    setLoadingWeek(true);
    Get({
      url: "/timetable/showweeks",
      data: data,
    }).then(res => {
      setWeek(res);
      setDays([
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ]);
      setLoadingWeek(false);
    });
  };
  const convertDay = day => {
    switch (day) {
      case "Wednesday":
        return "چهارشنبه";
      case "Thursday":
        return "پنج شنبه";
      case "Friday":
        return "جمعه";
      case "Monday":
        return "دوشنبه";
      case "Tuesday":
        return "سه شنبه";
      case "Saturday":
        return "شنبه";
      case "Sunday":
        return "یک شنبه";
      default:
        break;
    }
  };
  const statusHandler = (data, day, status) => {
    let result = {};
    if (status) {
      result = {
        style: {
          background: "#DDFFE8",
          color: "#05974d",
          // padding: "14px",
          borderStyle: "dashed",
          borderColor: "#dddddd",
          borderWidth: 1,
          cursor: "pointer",
          fontWeight: "200",
        },
        needData: true,
      };
    } else {
      if (
        compaireTwoDate(day, moment().format("YYYY/MM/DD"), data.time) &&
        compaireTwoDate(day, moment().format("YYYY/MM/DD"), data.time) !=
          "today"
      ) {
        result = {
          text: "گذشته ",
          style: {
            backgroundColor: "#fafafa",
            color: "#ccc",
            // padding: "14px",
            fontWeight: "200",
            cursor: "pointer",
          },
          status: false,
          pass: true,
        };
      } else {
        if (data && data.status) {
          let stat = data.status;
          if (stat == "future") {
            result = {
              text: "بدون قرارداد ",
              style: {
                backgroundColor: "#fafafa",
                color: "#ccc",
                // padding: "14px",
                fontWeight: "200",
                cursor: "pointer",
              },
              status: false,
              pass: true,
            };
          } else if (stat == "last") {
            result = {
              text: "گذشته ",
              style: {
                backgroundColor: "#fafafa",
                color: "#ccc",
                // padding: "14px",
                fontWeight: "200",
                cursor: "pointer",
              },
              status: false,
              pass: true,
            };
          }
        } else {
          if (+data.capacity >= 1) {
            result = {
              style: {
                background: "#DDFFE8",
                color: "#05974d",
                // padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              needData: true,
            };
          } else {
            result = {
              style: {
                background: "rgba(225,97,66,1)",
                color: "#fff",
                // padding: "14px",
                borderStyle: "dashed",
                borderColor: "#dddddd",
                borderWidth: 1,
                cursor: "pointer",
                fontWeight: "200",
              },
              empty: true,
              text: "اتمام ظرفیت",
            };
          }
        }
      }
    }

    return result;
  };
  const getDate = (date, week, jalali) => {
    if (week && date) {
      if (jalali) {
        return week.times[date].date;
      }
      return `${ToDateJalali(week.times[date].date).split("/")[1]}/${
        ToDateJalali(week.times[date].date).split("/")[2]
      }`;
    }
  };
  const getYear = (date, week) => {
    if (date && week) {
      return `${ToDateJalali(week.data[date].date).split("/")[0]}`;
    }
  };
  const checkCurrentWeek = data => {
    let result = false;
    if (data) {
      days.map(day => {
        if (data.data[day].date == new Date().toISOString().split("T")[0]) {
          result = true;
        }
      });
    }

    return result;
  };

  return {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    statusHandler,
    getDate,
    loadingSans,
    checkCurrentWeek,
    getYear,
  };
};
